/* eslint react/no-danger: 'off' */
/* global translations */
import React, { Component } from 'react';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

class VipWorks extends Component {
  state = {
    extended: false,
  };

  toggleExtended = (e) => {
    const { extended } = this.state;
    this.setState({ extended: !extended });

    e.currentTarget.blur();
  };

  render() {
    const { extended } = this.state;

    return (
      <div className="mbm">
        <div
          role="button"
          onClick={this.toggleExtended}
          onKeyDown={this.toggleExtended}
          tabIndex="0"
          className="btn btn--c btn--block btn--iconLeft btn--small vip-worksTitle"
        >
          <span>{get(translations, 'txt: Kā darbojas VIP?', '')}</span>
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg={extended ? 'icon-arrowup' : 'icon-arrowdown'} />
              </span>
            </span>
          </span>
        </div>
        {extended && (
          <div className="tss ptm plm">
            <div className="mbm">
              {get(translations, 'txt: Ar aktīvu VIP abonementu, VIP režīmu iespējams ieslēgt un izslēgt jebkurā brīdī.', '')}
            </div>
            <div
              className="mbxs"
              dangerouslySetInnerHTML={{
                __html: get(translations, 'txt: Lai ierobežotu ļaunprātīgu anonimitātes izmantošanu, atrodoties VIP režīmā, dažas darbības nevar veikt.', ''),
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default VipWorks;
